import styled from 'styled-components';

export const OpenInMapsAnchor = styled.a`
  text-decoration: underline;
  font-weight: 500;
  color: ${({ theme }): string => theme.colors.secondary};
  align-self: flex-start;
`;
